
export class ClientePagos {
   
    numeroDocumento: string;
    nombre: string;
    correo:string;
    tipo_documento:string;
    celular:string;
}